import React from "react";

type Props = {
    errorMessage: string
}

const ErrorMessage: React.FC<Props> = ({ errorMessage }) => {
    return (
        <div className="text-danger" role="alert">
            {errorMessage}
        </div>
    )
}

export { ErrorMessage }